'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.default = RecentlyViewedProducts;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _storage = require('./storage');

var _storage2 = _interopRequireDefault(_storage);

var _productRelatedCarousel = require('../product-related-carousel');

var _productRelatedCarousel2 = _interopRequireDefault(_productRelatedCarousel);

var _functional = require('../../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var className = 'js-RecentlyViewedProducts';

function RecentlyViewedProducts(el) {
  this.relatedCarousel = window.productRelatedCarousel;
  this.els = {
    el: el,
    carousel: (0, _functional.getElement)('.' + className + '_Carousel', { context: el }),
    items: (0, _functional.getElement)('.' + className + '_Items', { context: el }),
    related: (0, _functional.getElement)('.' + className + '_Related')
  };

  this.totalProductsAdded = 0;
  this.carouselSlideClass = 'rel-Carousel_Item';
  this.storage = new _storage2.default();
  this.productHandles = this.storage.getHandles();

  this.productHandles && this.productHandles.length > 1 ? this.moveAlong() : this.destroy();
}

RecentlyViewedProducts.prototype.moveAlong = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var handle, _ref2, data;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!this.productHandles.length) {
              _context.next = 15;
              break;
            }

            handle = this.productHandles.shift();

            // If we're on a product page and it's in the recently viewed, ignore it

            if (!window.location.pathname.includes(handle)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt('return', this.moveAlong());

          case 6:
            _context.next = 8;
            return (0, _axios2.default)({
              url: '/products/' + handle + '.js',
              dataType: 'json'
            });

          case 8:
            _ref2 = _context.sent;
            data = _ref2.data;


            this.createCarouselSlide(data);

            this.totalProductsAdded += 1;

            return _context.abrupt('return', this.moveAlong());

          case 13:
            _context.next = 16;
            break;

          case 15:
            this.finalize();

          case 16:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  function moveAlong() {
    return _ref.apply(this, arguments);
  }

  return moveAlong;
}();

RecentlyViewedProducts.prototype.createCarouselSlide = function createCarouselSlide(data) {
  var element = (0, _functional.createElement)('div', {
    class: this.carouselSlideClass
  });
  var productCard = this.createProductCard({
    available: data['available'],
    compareAtPrice: data['compare_at_price'],
    featuredImage: data['featured_image'],
    images: data['images'],
    price: data['price'],
    tags: data['tags'],
    title: data['title'],
    variants: data['variants'],
    url: data['url']
  });

  element.appendChild(productCard);

  this.els.items.appendChild(element);

  return element;
};

RecentlyViewedProducts.prototype.createProductCard = function createProductCard(data) {
  var available = data.available,
      compareAtPrice = data.compareAtPrice,
      price = data.price,
      tags = data.tags;

  var wantedTags = ['__new', '__sophieloves', '__preorder', '__comingsoon', '__back-in-stock'];
  var needsTagsEl = tags.some(function (tag) {
    return wantedTags.includes(tag);
  }) || available;
  var onSale = compareAtPrice > price;

  var template = (0, _functional.getElement)('#product-card-template');
  var card = document.importNode(template.content, true);

  var cardContext = { context: card };

  var removeElement = function removeElement(el) {
    return el.remove();
  };

  var elements = {
    images: {
      featured: (0, _functional.getElement)('.prd-Card_Image', cardContext),
      hover: (0, _functional.getElement)('.prd-Card_Image-hover', cardContext)
    },
    tags: {
      container: (0, _functional.getElement)('.prd-Card_Tags', cardContext),
      new: (0, _functional.getElement)('.prd-Card_Tag-new', cardContext),
      love: (0, _functional.getElement)('.prd-Card_Tag-love', cardContext),
      pre: (0, _functional.getElement)('.prd-Card_Tag-pre', cardContext),
      coming: (0, _functional.getElement)('.prd-Card_Tag-coming', cardContext),
      backinstock: (0, _functional.getElement)('.prd-Card_Tag-backInStock', cardContext),
      sale: (0, _functional.getElement)('.prd-Card_Tag-sale', cardContext),
      soldOut: (0, _functional.getElement)('.prd-Card_Tag-soldOut', cardContext)
    },
    price: {
      compare: (0, _functional.getElement)('.prd-Card_PriceCompare', cardContext),
      compareRegular: (0, _functional.getElement)('.prd-Card_PriceCompareRegular', cardContext),
      regular: (0, _functional.getElement)('.prd-Card_PriceRegular', cardContext)
    },
    content: {
      title: (0, _functional.getElement)('.prd-Card_Title', cardContext)
    },
    form: {
      id: (0, _functional.getElement)('input[name="id"]', cardContext),
      variantsContainer: (0, _functional.getElement)('.prd-Card_Variants', cardContext),
      variant: (0, _functional.getElement)('.prd-Card_Variant', cardContext)
    },
    link: {
      link: (0, _functional.getElement)('.prd-Card_FauxLink', cardContext),
      title: (0, _functional.getElement)('.prd-Card_FauxLink span', cardContext)
    }
  };

  var featuredImage = createResponsiveImage(data.featuredImage);
  var hoverImageSrc = data.images[1] || data.featuredImage;
  var hoverImage = createResponsiveImage(hoverImageSrc);

  if (elements.images.featured && featuredImage) {
    elements.images.featured.appendChild(featuredImage);
  }

  if (elements.images.hover && hoverImage) {
    elements.images.hover.appendChild(hoverImage);
  }

  if (needsTagsEl === false) {
    removeElement(elements.tags.container);
  } else {
    if (tags.includes('__new') === false) {
      removeElement(elements.tags.new);
    }

    if (tags.includes('__sophieloves') === false) {
      removeElement(elements.tags.love);
    }

    if (tags.includes('__preorder') === false) {
      removeElement(elements.tags.pre);
    }

    if (tags.includes('__comingsoon') === false) {
      removeElement(elements.tags.coming);
    }

    if (tags.includes('__back-in-stock') === false) {
      removeElement(elements.tags.backinstock);
    }

    if (onSale === false) {
      removeElement(elements.tags.sale);
    }

    if (available) {
      removeElement(elements.tags.soldOut);
    }
  }

  elements.content.title.textContent = data.title;

  if (onSale) {
    removeElement(elements.price.regular);

    elements.price.compare.textContent = (0, _functional.formatMoney)(compareAtPrice);
    elements.price.compareRegular.textContent = (0, _functional.formatMoney)(data.price);
  } else {
    removeElement(elements.price.compare);
    removeElement(elements.price.compareRegular);

    elements.price.regular.textContent = (0, _functional.formatMoney)(data.price);
  }

  elements.form.id.value = data.variants[0].id;

  if (data.variants.length <= 1) {
    removeElement(elements.form.variantsContainer);
  } else {
    var variantEl = elements.form.variant;
    var variants = [].concat((0, _toConsumableArray3.default)(data.variants));
    var firstVariant = variants.shift();
    variantEl.dataset.variantId = firstVariant.id;
    variantEl.setAttribute('aria-disabled', String(firstVariant.available));
    variantEl.setAttribute('aria-selected', 'true');
    variantEl.textContent = firstVariant.option1;

    if (variants.length) {
      variants.forEach(function (variant) {
        var variantClone = variantEl.cloneNode();

        variantClone.dataset.variantId = variant.id;
        variantClone.setAttribute('aria-disabled', String(variant.available));
        variantClone.setAttribute('aria-selected', 'false');
        variantClone.textContent = variant.option1;

        elements.form.variantsContainer.appendChild(variantClone);
      });
    }
  }

  elements.link.link.href = data.url;
  elements.link.title.textContent = data.title;

  return card;
};

RecentlyViewedProducts.prototype.finalize = function finalize() {
  if (this.totalProductsAdded > 2) {
    this.buildCarousel();
  } else {
    this.els.carousel.classList.add('rel-Related_Carousel-noCarousel');
  }

  this.els.el.classList.add('js-RecentlyViewedProducts-active');
};

RecentlyViewedProducts.prototype.buildCarousel = function buildCarousel() {
  /* eslint-disable */
  new _productRelatedCarousel2.default(this.els.carousel);
  /* eslint-enable */

  var images = (0, _from2.default)(this.els.carousel.querySelectorAll('.rsp-Image'));
  images.forEach(function (image) {
    return window.lazySizes.loader.unveil(image);
  });
};

RecentlyViewedProducts.prototype.destroy = function destroy() {
  this.els.el.remove();

  this.els.related.classList.add('rel-Related_Item-full');

  if (this.relatedCarousel) {
    this.relatedCarousel.flkty.resize();
  }
};

function createResponsiveImage(src) {
  var wrapper = (0, _functional.createElement)('div', {
    class: 'rsp-Image'
  });
  var image = (0, _functional.createElement)('img', {
    class: 'rsp-Image_Image lazyload',
    src: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
    'data-lowsrc': (0, _functional.resizeImage)({ src: src, size: '20x' }),
    'data-src': (0, _functional.resizeImage)({ src: src, size: '500x500', crop: 'center' }),
    'data-widths': '[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1944, 2160, 2376, 2592, 2808, 3024]',
    'data-aspectratio': '1.0',
    'data-sizes': 'auto'
  });

  wrapper.appendChild(image);

  return wrapper;
}